import { ListScaffold, type ListRow } from "@/components/ListScaffold";

// Quotes (presentational scaffolding). Mirrors the Submissions tab's structure
// and look with placeholder rows; nothing is wired.
const ROWS: ListRow[] = [
  {
    id: "QUO-2041",
    account: "Acme Builders LLC",
    coverage: "General Liability",
    date: "2026-02-03",
    status: "quoted",
    carrier: "Travelers",
  },
  {
    id: "QUO-2042",
    account: "Summit Point Contractors",
    coverage: "Workers Compensation",
    date: "2026-02-05",
    status: "quoted",
    carrier: "Pie",
  },
  {
    id: "QUO-2043",
    account: "Ironwood Construction",
    coverage: "Commercial Auto",
    date: "2026-01-28",
    status: "quoted",
    carrier: "Nationwide",
  },
  {
    id: "QUO-2044",
    account: "Harbor Freight Co",
    coverage: "Builders Risk",
    date: "2026-02-10",
    status: "quoted",
    carrier: "Chubb",
  },
];

export function QuotesPage() {
  return (
    <ListScaffold
      title="Quotes"
      subtitle="Quotes returned across your submitted markets."
      idLabel="Quote"
      noun="quotes"
      rows={ROWS}
    />
  );
}
